import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage/LazyImage";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    desktopimage = "desktopimage",
    mobileimage = "mobileimage",
    alt = "alt",
}
interface OwnProps extends WidgetProps {
    fields: {
        [fields.desktopimage]: string;
        [fields.mobileimage]: string;
        [fields.alt]: string;
    };
}

const mapStateToProps = (state: ApplicationState, ownProps: { categoryId: string }) => ({
    currentPage: getCurrentPage(state),
    category: getCategoryState(state, ownProps.categoryId).value,
});

type Props = WidgetProps & HasCategoryContext & OwnProps & ReturnType<typeof mapStateToProps>;

export interface SurCategoryBannerStyles {
    ImageContainer?: InjectableCss;
    BannerImage?: LazyImageProps;
}

export const SurCategoryBannerStyles: SurCategoryBannerStyles = {
    ImageContainer: {
        css: css`
            display: flex;
            .bannerImage {
                width: 100%;
                img {
                    width: 100%;
                }
            }
        `,
    },
    BannerImage: {
        css: css`
            width: 100%;
            img {
                width: 100%;
                height: auto;
                aspect-ratio: 16/5;
                object-fit: cover;
            }
        `,
    },
};

const styles = SurCategoryBannerStyles;

export const SurCategoryBanner: FC<Props> = ({ category }) => {
    return (
        <StyledWrapper {...styles.ImageContainer}>
            <picture className="bannerImage">
                <LazyImage src={category?.properties.categoryBannerImage} altText="Catgeory Banner" {...styles.BannerImage} />
            </picture>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withCategory(SurCategoryBanner)),
    definition: {
        group: "Basic",
        icon: "image",
        displayName: "SurCategoryBanner",
        fieldDefinitions: [],
    },
};

export default widgetModule;
